import { ActionTree } from 'vuex';
import GeometryService from '@/services/geometry.service';
import TollDomainService from '@/services/tolldomain.service';
import {
  FETCH_TOLL_DOMAINS,
  FETCH_TOTAL_TOLL_DOMAINS,
  FETCH_TOLL_DOMAIN_INFO_BY_ID,
  SET_ERROR,
  TollDomainState,
  UPDATE_DOMAINS_STATE,
  REINIT,
  USER_SELECTION_REGISTER_DOMAIN,
  USER_SELECTION_CLEAR_DOMAINS,
  USER_SELECTION_RESET_ACTIONS,
  TRIGGER_DOMAIN_USER_SELECTION_ACTION,
  UPDATE_NAVIGATION,
  TOLL_DOMAIN_NAVIGATION,
  CREATE_GEOMETRY,
  ACTIVATE_GEOMETRY,
  CREATE_RULE,
  UPDATE_RULE,
  FETCH_RULE_BY_ID,
  TOLL_DOMAIN_IS_UNIQUE,
  FETCH_GEODIFF,
  FETCH_CURRENT_GEO,
  FETCH_PERIODS,
  FETCH_GEOJSON,
  FETCH_VARIANTS,
  FETCH_VARIANT_BY_ID,
  FETCH_DEFAULT_VARIANT,
  CREATE_VARIANT
} from './types';
import { TollDomainGeometryApiCaller as TollDomainGeometryApi, TollDomainApiCaller as TollDomainApi, TollDomainVariantApiCaller as TollDomainVariantApi } from './callers';

const actions: ActionTree<TollDomainState, Record<string, never>> = {
  [REINIT]({ commit }): void {
    commit(REINIT);
  },
  [UPDATE_NAVIGATION]({ commit }, payload): void {
    commit(UPDATE_NAVIGATION, payload);
  },
  [TOLL_DOMAIN_NAVIGATION]({ commit }, payload): void {
    commit(TOLL_DOMAIN_NAVIGATION, payload);
  },
  [USER_SELECTION_REGISTER_DOMAIN]({ commit }, payload): void {
    commit(USER_SELECTION_REGISTER_DOMAIN, payload);
  },
  [USER_SELECTION_CLEAR_DOMAINS]({ commit }): void {
    commit(USER_SELECTION_CLEAR_DOMAINS);
  },
  [USER_SELECTION_RESET_ACTIONS]({ commit }): void {
    commit(USER_SELECTION_RESET_ACTIONS);
  },
  [TRIGGER_DOMAIN_USER_SELECTION_ACTION]({ commit }, payload): void {
    commit(TRIGGER_DOMAIN_USER_SELECTION_ACTION, payload);
  },
  [FETCH_TOLL_DOMAIN_INFO_BY_ID]({ commit }, payload): Promise<void> {
    return TollDomainApi.tollDomainDetails(payload.id)
      .then((res) => {
        commit(FETCH_TOLL_DOMAIN_INFO_BY_ID, res);
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'fetched',
          stateValue: true
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'error',
          stateValue: false
        });
      })
      .catch((res) => {
        commit(SET_ERROR, res.message);
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'error',
          stateValue: true
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'fetched',
          stateValue: false
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'loading',
          stateValue: false
        });
      });
  },
  async [FETCH_TOLL_DOMAINS]({ commit, rootGetters }, payload): Promise<void> {
    const master = rootGetters['user/getSelectedMasterAccount'];
    if (master.id < 1) return Promise.resolve();
    commit(UPDATE_DOMAINS_STATE, {
      view: 'tolldomains',
      stateKey: 'loading',
      stateValue: true
    });
    commit(UPDATE_DOMAINS_STATE, {
      view: 'tolldomains',
      stateKey: 'fetched',
      stateValue: false
    });
    commit(UPDATE_DOMAINS_STATE, {
      view: 'tolldomains',
      stateKey: 'error',
      stateValue: false
    });
    return TollDomainApi.listTollDomains(payload.domainsPerPage, master.id, payload.start, payload.hideObsolete, payload.variant)
      .then((res) => {
        commit(FETCH_TOLL_DOMAINS, res);
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'fetched',
          stateValue: true
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'error',
          stateValue: false
        });
      })
      .catch((res) => {
        commit(SET_ERROR, res.message);
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'error',
          stateValue: true
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'fetched',
          stateValue: false
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'loading',
          stateValue: false
        });
      });
  },
  async [FETCH_TOTAL_TOLL_DOMAINS]({ commit, rootGetters }, payload: any) {
    const master = rootGetters['user/getSelectedMasterAccount'];
    if (master.id < 1) return Promise.resolve();
    commit(UPDATE_DOMAINS_STATE, {
      view: 'total',
      stateKey: 'loading',
      stateValue: true
    });
    commit(UPDATE_DOMAINS_STATE, {
      view: 'total',
      stateKey: 'fetched',
      stateValue: false
    });
    commit(UPDATE_DOMAINS_STATE, {
      view: 'total',
      stateKey: 'error',
      stateValue: false
    });
    return TollDomainApi.countTollDomains(master.id, payload.variant, payload.hideObsolete)
      .then((res) => {
        commit(FETCH_TOTAL_TOLL_DOMAINS, res);
        commit(UPDATE_DOMAINS_STATE, {
          view: 'total',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'total',
          stateKey: 'fetched',
          stateValue: true
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'total',
          stateKey: 'error',
          stateValue: false
        });
      })
      .catch((res) => {
        commit(SET_ERROR, res.message);
        commit(UPDATE_DOMAINS_STATE, {
          view: 'total',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'total',
          stateKey: 'fetched',
          stateValue: false
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'total',
          stateKey: 'error',
          stateValue: true
        });
      });
  },
  async [FETCH_RULE_BY_ID]({ commit }, payload): Promise<void> {
    commit(UPDATE_DOMAINS_STATE, {
      view: 'tolldomains',
      stateKey: 'loading',
      stateValue: true
    });
    commit(UPDATE_DOMAINS_STATE, {
      view: 'tolldomains',
      stateKey: 'fetched',
      stateValue: false
    });
    commit(UPDATE_DOMAINS_STATE, {
      view: 'tolldomains',
      stateKey: 'error',
      stateValue: false
    });
    return TollDomainApi.getRuleById(payload.id)
      .then((res) => {
        commit(FETCH_RULE_BY_ID, res);
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'fetched',
          stateValue: true
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'error',
          stateValue: false
        });
      })
      .catch((res) => {
        commit(SET_ERROR, res.message);
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'error',
          stateValue: true
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'fetched',
          stateValue: false
        });
        commit(UPDATE_DOMAINS_STATE, {
          view: 'tolldomains',
          stateKey: 'loading',
          stateValue: false
        });
      });
  },
  // SWAGGER CODEGEN BUG - multipart not supported for file upload
  async [CREATE_RULE](_, payload): Promise<any> {
    return TollDomainService.createRule(payload.rule, payload.id, payload.contact, payload.countryCode, payload.tspCode);
  },
  async [UPDATE_RULE](_, payload): Promise<any> {
    return TollDomainService.updateRule(payload.rule, payload.id, payload.contact, payload.countryCode, payload.tspCode);
  },
  async [TOLL_DOMAIN_IS_UNIQUE](_, payload): Promise<boolean> {
    return TollDomainApi.checkUnicityTollDomain(payload.tollDomainName, payload.masterId).then(() => true).catch(() => false);
  },
  async [CREATE_GEOMETRY](_, payload): Promise<any> {
    return GeometryService.createGeometry(payload.geometryName, payload.startTs, payload.masterId, payload.geoZip);
  },
  async [ACTIVATE_GEOMETRY](_, payload): Promise<any> {
    return TollDomainService.activateGeometry(payload);
  },
  [FETCH_PERIODS](_, payload: { masterId: number, variantId: number }) {
    return TollDomainGeometryApi.getPeriods(payload.masterId, payload.variantId);
  },
  [FETCH_GEOJSON](_: any, payload: any) {
    return TollDomainGeometryApi.getGeometryGeoJSON(payload.masterId, payload.countryCode, payload.variantId, payload.endTs);
  },
  [FETCH_GEODIFF](_: any, payload: any) {
    return TollDomainGeometryApi.getGeometryDiff(payload.masterId, payload.geometryId, payload.variantId).catch(err => ({ message: err.toString() }));
  },
  [FETCH_CURRENT_GEO]({ rootGetters }, payload: number) {
    const master = rootGetters['user/getSelectedMasterAccount'];
    if (master.id < 1) return Promise.resolve();
    return TollDomainGeometryApi.getExternalCurrentGeometryID(master.id, payload).catch(err => ({ message: err }));
  },
  async [FETCH_VARIANT_BY_ID]({ rootGetters }, variantId: number) {
    const master = rootGetters['user/getSelectedMasterAccount'];
    if (master.id < 1) return Promise.resolve();
    return TollDomainVariantApi.getVariant(variantId, master.id).catch(err => ({ message: err.toString() }));
  },
  async [FETCH_DEFAULT_VARIANT]({ rootGetters }) {
    const master = rootGetters['user/getSelectedMasterAccount'];
    if (master.id < 1) return Promise.resolve();
    return TollDomainVariantApi.getDefaultVariant(master.id).catch(err => ({ message: err.toString() }));
  },
  async [CREATE_VARIANT]({ rootGetters }, variant: string): Promise<any> {
    const master = rootGetters['user/getSelectedMasterAccount'];
    if (master.id < 1) return Promise.resolve();
    return TollDomainVariantApi.createVariant({ masterId: master.id, name: variant })
      .catch((response: Response) => response.text().then((text) => {
        const res = JSON.parse(text);
        const content = res.code ? `common.error.${res.code}` : res;
        return { message: content };
      }));
  },
  async [FETCH_VARIANTS]({ commit, rootGetters }): Promise<void> {
    const master = rootGetters['user/getSelectedMasterAccount'];
    if (master.id < 1) return Promise.resolve();
    return TollDomainVariantApi.getAllVariants(master.id)
      .then((res) => {
        commit(FETCH_VARIANTS, res);
      })
      .catch((res) => {
        commit(SET_ERROR, res.message);
      });
  }
};
export default actions;
